import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";

export function initI18n() {
	i18n.use(initReactI18next)
		.use(LanguageDetector)
		.init({
			detection: {
				order: ["navigator"],
			},
			resources: {
				en: { translation: en },
				de: { translation: de },
				ja: { translation: ja },
			},
			supportedLngs: ["en", "de", "ja"],
			fallbackLng: "en",
			interpolation: {
				escapeValue: false,
			},
		});
}
